import React, { FC } from "react";
import { Field, FormRenderProps, useFormState } from "react-final-form";
import { Typography, makeStyles } from "@material-ui/core";
import Autocomplete from "../../../../components/Autocomplete";

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: "100%",
    height: 136,
    "& > div": {
      marginTop: 20,
    },
  },
}));

const ChooseStudentForm: FC<FormRenderProps> = ({ handleSubmit }) => {
  const classes = useStyles();
  const formData = useFormState();
  const values = formData.values;
  const students = values.injectedData.students;

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className={classes.mainContainer}>
        <Typography>
          Please select a student to send a message on behalf of
        </Typography>
        <Field
          fullWidth
          required
          name="chooseStudent.student"
          label="Student"
          placeholder="Please select a student"
          options={students}
          component={Autocomplete}
        />
      </div>
    </form>
  );
};

export default ChooseStudentForm;
